import { Link } from 'react-router-dom';

/** 초기 화면. Dr corner 브랜드를 소개하고 전체 상품으로 안내한다. */
export default function BrandPage() {
  return (
    <>
      <section className="brand-hero">
        <div className="brand-hero__body">
          <p className="brand-eyebrow">NATURAL CLEAN BEAUTY</p>
          <h1>Dr corner</h1>
          <p className="brand-hero__lead">
            자연주의 클린뷰티.
            <br />
            클로렐라 성장인자(CGF)를 담은 Gency03 스킨케어 라인입니다.
          </p>
          <Link to="/products" className="btn btn--lg brand-hero__cta">
            상품 보기
          </Link>
        </div>
      </section>

      <section className="brand-story">
        <div className="brand-story__text">
          <p className="brand-eyebrow">BRAND STORY</p>
          <h2>피부가 스스로 회복하는 힘, CGF</h2>
          <p>
            Chlorella Growth Factor 는 클로렐라에서 얻은 성장인자입니다. Dr corner 는 이 자연 유래 성분을
            중심으로, 꼭 필요한 것만 담은 깨끗한 처방을 지향합니다.
          </p>
          <p>
            과하지 않게, 그러나 꾸준하게. 매일의 루틴 속에서 피부 본연의 건강함을 되찾도록 돕는 것이
            Dr corner 가 생각하는 클린뷰티입니다.
          </p>
        </div>
        <video
          className="brand-story__film"
          src="/brand/film.mp4"
          poster="/brand/film-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          aria-label="Dr corner 브랜드 영상"
        />
      </section>

      <section className="brand-lineup">
        <div className="brand-lineup__head">
          <p className="brand-eyebrow">LINE-UP</p>
          <h2>Pure Skin Serum</h2>
          <p className="muted">30ml · 50ml · 150ml, 쓰는 방식에 맞춰 고르는 세 가지 용량</p>
        </div>
        <img src="/brand/lineup.jpg" alt="Dr corner Pure Skin Serum 30ml, 50ml, 150ml" />
      </section>

      <section className="brand-palette">
        <figure>
          <img src="/brand/set-mint.jpg" alt="민트 패키지의 Dr corner 제품" />
          <figcaption>Minimalist White &amp; Mint</figcaption>
        </figure>
        <figure>
          <img src="/brand/set-silver.jpg" alt="실버 패키지의 Dr corner 제품" />
          <figcaption>Silver Package</figcaption>
        </figure>
      </section>

      <section className="brand-closing">
        <h2>Dr corner 의 모든 제품을 만나 보세요</h2>
        <Link to="/products" className="btn btn--primary btn--lg">
          상품 보기
        </Link>
      </section>
    </>
  );
}
